<div class="login-page d-flex flex-column flex-root" id="kt_app_root">
  <div class="d-flex flex-column flex-lg-row flex-column-fluid min-vh-100">
    <!-- Form Side -->
    <div
      class="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1"
    >
      <div class="d-flex flex-center flex-column flex-lg-row-fluid">
        <div class="w-lg-500px p-10">
          <div class="text-center mb-11">
            <h1 class="text-gray-900 fw-bolder mb-3" style="font-size: 2.25rem">
              {{ "resetPassword.title" | translate }}
            </h1>

            <div class="text-gray-500 fw-semibold" style="font-size: 1.25rem">
              {{ "resetPassword.subTitle" | translate }}
            </div>
          </div>
          <!-- Reset Password -->
          <form
            [formGroup]="resetPasswordForm"
            class="form w-100"
            novalidate="novalidate"
            id="kt_sign_in_form"
            data-kt-redirect-url="#"
            action="#"
          >
            <div class="col-md-12 mt-4">
              <div class="form-floating">
                <input
                  formControlName="password"
                  class="form-control"
                  id="inputNewPassword"
                  type="password"
                  placeholder="Secret password"
                />
                <label for="inputNewPassword">{{
                  "newPassword" | translate
                }}</label>
                <div
                  *ngIf="isResetPasswordControlInvalid('password')"
                  class="text-danger"
                >
                  <div
                    *ngIf="resetPasswordForm.get('password')?.errors?.['required']"
                  >
                    {{ "newPasswordRequired" | translate }}
                  </div>
                  <div
                    *ngIf="resetPasswordForm.get('password')?.errors?.['minlength']"
                  >
                    {{ "newPasswordMustBeAtLeast8Characters" | translate }}
                  </div>
                  <div
                    *ngIf="resetPasswordForm.get('password')?.errors?.['pattern']"
                  >
                    {{
                      "newPasswordMustContainAtLeastOneUppercaseLetterAndOneSpecialCharacter"
                        | translate
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 mt-4">
              <div class="form-floating">
                <input
                  formControlName="confirmPassword"
                  class="form-control"
                  id="inputNewConfirmPassword"
                  type="password"
                  placeholder="Confirm Password"
                />
                <label for="inputNewConfirmPassword">{{
                  "confirmPassword" | translate
                }}</label>
                <div class="text-danger">
                  <div
                    *ngIf="resetPasswordForm.get('confirmPassword')?.errors?.['required']"
                  >
                    {{ "confirmPasswordRequired" | translate }}
                  </div>
                  <div
                    *ngIf="resetPasswordForm.get('confirmPassword')?.errors?.['minlength']"
                  >
                    {{
                      "confirmPasswordMustBeAtLeast8CharactersLong" | translate
                    }}
                  </div>
                  <div
                    *ngIf="resetPasswordForm.get('confirmPassword')?.errors?.['pattern']"
                  >
                    {{
                      "confirmPasswordMustContainAtLeastOneUppercaseLetterAndOneSpecialCharacter"
                        | translate
                    }}
                  </div>
                  <div
                    *ngIf="resetPasswordForm.get('confirmPassword')?.errors?.['passwordMismatch']"
                  >
                    {{ "passwordsDoNotMatch" | translate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="d-grid mb-10">
              <button type="submit" class="btn btn-primary cursor-pointer">
                <span class="indicator-label">
                  {{ "resetPassword.setNewPassword" | translate }}
                </span>
              </button>
            </div>
          </form>

          <!-- Back to login -->
          <div class="d-grid mb-10">
            <p class="text-center mt-2">
              <a class="text-primary" routerLink="/auth/login"
                ><i class="feather icon-chevron-left"></i
                >{{ "backToLogin" | translate }}</a
              >
            </p>
          </div>
          <div
            class="w-lg-500px d-flex flex-stack px-10 mx-auto"
            style="justify-content: end"
          ></div>
        </div>
      </div>
    </div>

    <!-- Image Side -->
    <div
      class="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2"
      style="background-image: url(assets/media/misc/auth-bg.png)"
    >
      <app-welcome-image class="w-100"></app-welcome-image>
    </div>
  </div>
</div>
